import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { ReportsControllerModule } from './controllers/ReportsController';
import { ReportsCreateView } from './create/create';
import { ReportsListView } from './list/list';
import { ReportsMappingsView } from './mappings/mappings';
import { ReportsPrintView } from './print/print';
import { ReportsResultView } from './result/result';
import { ReportsResultsView } from './results/results';

export const ReportsView = angular
  .module('acme.view.application.reports', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    ReportsControllerModule,
    ReportsListView,
    ReportsResultView,
    ReportsResultsView,
    ReportsPrintView,
    ReportsCreateView,
    ReportsMappingsView,
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const reports = {
      name: 'application.reports',
      url: '/reports',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'ReportsController',
          templateUrl: 'views/application/views/reports/reports.tpl.html',
        },
      },
      data: {
        pageTitle: 'Reports',
        permissions: ['REPORTS_VIEW'],
      },
    };

    $stateProvider.state(reports);
  }).name;
